import { render, staticRenderFns } from "./SelectDescription.vue?vue&type=template&id=1a7eb22e&"
import script from "./SelectDescription.vue?vue&type=script&lang=ts&"
export * from "./SelectDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports